import { useState } from "react";
import { HelpIndicator } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { hasUnlinkSubjectIds } from "./hasUnlinkSubjectIds";
import { OnboardingUnlinkModal, type OnboardingSubjectKind } from "./OnboardingUnlinkModal";
import { caseLinkIcon } from "./styles_vanilla.css";

type Props = {
  subjectKind: OnboardingSubjectKind;
  subjectId: number;
  subjectName: string;
  arenaId: number;
  onUnlinked: () => void;
};

/** Unlink control for a linked onboarding case — the same hover-revealed `unlink` icon as Positions. */
export const OnboardingUnlinkMenu = ({
  subjectKind,
  subjectId,
  subjectName,
  arenaId,
  onUnlinked,
}: Props) => {
  const [showUnlinkModal, setShowUnlinkModal] = useState(false);
  const label = `Unlink case from this ${subjectKind}`;

  if (!hasUnlinkSubjectIds(subjectId, arenaId)) {
    return null;
  }

  return (
    <>
      <HelpIndicator
        id={`unlink-${subjectKind}-${subjectId}-tooltip`}
        placement="top"
        content={label}
      >
        <Icon
          className={`${caseLinkIcon} hover-icon`}
          type="unlink"
          title={label}
          color={Colors.Primary600}
          onClick={() => setShowUnlinkModal(true)}
          data-testid="unlink-icon"
        />
      </HelpIndicator>
      {showUnlinkModal && (
        <OnboardingUnlinkModal
          isOpen
          onClose={() => setShowUnlinkModal(false)}
          subjectKind={subjectKind}
          subjectId={subjectId}
          subjectName={subjectName}
          arenaId={arenaId}
          onUnlinked={onUnlinked}
        />
      )}
    </>
  );
};
